import { Injectable } from '@angular/core';

/**
 * Owns the lifecycle of the static splash screen injected into index.html.
 * Kept in a service so App stays clean and the dismiss logic is testable/injectable.
 */
@Injectable({ providedIn: 'root' })
export class SplashService {
  private static readonly ID         = 'al';
  private static readonly EXIT_CLASS = 'al-out';

  dismiss(): void {
    const el = document.getElementById(SplashService.ID);
    if (!el) return;

    el.classList.add(SplashService.EXIT_CLASS);

    // Remove from DOM once the CSS transition finishes — no magic timeouts.
    el.addEventListener('transitionend', () => el.remove(), { once: true });
  }
}
